"use client";

import { Plus } from "lucide-react";

export function NewChatButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      aria-label="Start a new chat"
      className="flex items-center gap-1 rounded-md px-2 py-1 text-[13px] text-[var(--text-secondary)] hover:bg-[var(--hover-overlay)] hover:text-[var(--text-primary)]"
    >
      <Plus size={16} strokeWidth={1.5} />
      New chat
    </button>
  );
}
